import { Component, Input } from '@angular/core';

@Component({
  selector: 'cpd-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  @Input() public show = false;
  @Input() public shadow = true;
  @Input() public value = null;
  @Input() public mode: 'determinate' | 'indeterminate' = 'indeterminate';
}
